import { Component } from 'react';

class EMCNotFound extends Component {
    render() {
        return (
            <div className="search-results">
                <div className="search-result">
                    <div className="icon-css">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            fill="#ff0000"
                            height="64px"
                            width="64px"
                            viewBox="-0.72 -0.72 25.44 25.44"
                            enableBackground="new 0 0 24 24"
                            xmlSpace="preserve"
                            stroke="#ff0000"
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <g id="Status-Error-Filled">
                                    <path d="M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12s12-5.37,12-12S18.63,0,12,0z M18.38,16.62l-1.77,1.77L12,13.77l-4.62,4.62 l-1.77-1.77L10.23,12L5.62,7.38l1.77-1.77L12,10.23l4.62-4.62l1.77,1.77L13.77,12L18.38,16.62z"></path>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div className="result-title">{this.props.error_message}</div>
                </div>
            </div>
        )
    }
}

export default EMCNotFound;
